import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="border-t border-primary-100 bg-primary-50/40">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-sm">
            <a href="#top" className="flex items-baseline gap-1.5" aria-label="51黑料">
              <span className="font-display text-2xl font-black text-primary-600">
                51<span className="text-accent-600">黑料</span>
              </span>
            </a>
            <p className="mt-3 text-sm leading-relaxed text-primary-900/70">
              51黑料话题聚合站，每日更新热榜与精选盘点。从最新合集到往期汇总，按热度排序呈现当前讨论度高的黑料话题。
            </p>
            <div className="mt-4 flex items-center gap-3 text-primary-700">
              {['ri-arrow-right-up-line', 'ri-external-link-line', 'ri-question-line'].map((ic, i) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label={`社交链接 ${i + 1}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-primary-200 bg-background-50 transition hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-950">站内导航</h4>
              <ul className="mt-3 space-y-2 text-sm text-foreground-600">
                {navLinks.slice(0, 4).map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="transition hover:text-primary-700">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-950">内容分区</h4>
              <ul className="mt-3 space-y-2 text-sm text-foreground-600">
                {navLinks.slice(4).map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="transition hover:text-primary-700">
                      {l.label}
                    </a>
                  </li>
                ))}
                <li><a href="#tags" className="transition hover:text-primary-700">热门标签</a></li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="font-heading text-sm font-bold text-foreground-950">内容说明</h4>
              <p className="mt-3 text-sm leading-relaxed text-foreground-500">
                站内话题以公开信息与讨论整理为主，素材归原作者所有，仅供信息聚合浏览。本站不生产与售卖任何违规内容。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-primary-100 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-400">© 2026 51黑料 · 话题热榜盘点 所有讨论内容归发布者所有</p>
          <p className="flex items-center gap-2 text-xs text-foreground-400">
            <span className="flex h-1.5 w-1.5 rounded-full bg-accent-500" />
            按热度排序 · 每日滚动更新 · 记录 #51黑料
          </p>
        </div>
      </div>
    </footer>
  );
}